import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { Icon, DataTable, Form, Heading6 } from '../components/widgets';
import { uuid } from '../helpers/common';
import { getUserId } from '../helpers/session';
import { uploadToGoogle } from '../helpers/web-agent';
import { getLoadSamplerUploadURL, getLoadSamplerRetrieveURL } from './utils';
import { LoadSamplingProfileSettings } from '../constants';
import { Unit } from '../helpers/unit';
import CutTopOrBottomIcon from '../../assets/images/CutTopOrBottom.png';
import BarrelCutBottomIcon from '../../assets/images/BarrelCutBottom.png';
import BarrelCutTopIcon from '../../assets/images/BarrelCutTop.png';
import HorizontalVerticalCutIcon from '../../assets/images/HorizontalVerticalCut.png';
import OneDropIcon from '../../assets/images/OneDrop.png';

const LoadSampleProfileTable = props => {
	const { show, onHide, load, farmId, saveSample } = props;
	const [seedSampleData] = useState((load && load['seed_piece_profile'] && load['seed_piece_profile'].length > 0) ? load['seed_piece_profile'] : []);
	const [loadSamplePieceData, setLoadSamplePieceData] = useState([]);
	const [initialSamplePieceData, setInitialSamplePieceData] = useState([]);
	const [samplerTabId, setSamplerTabId] = useState(null)
	const [isAdded, setIsAdded] = useState({ isAdding: false, id: null })
	const [isEdit, setIsEdit] = useState({ isEditing: false, id: null })
	const [defaultLoadSample, setDefaultLoadSample] = useState([])
	const [defaultSamplerFile, setDefaultSamplerFile] = useState([])
	const [samplerFiles, setSamplerFiles] = useState([]);
	const [samplerFileURL, setSamplerFileURL] = useState([]);
	const [isNewSample, setIsNewSample] = useState(false);
	const [error, setError] = useState(false)
	const unit = Unit.getInstance();
	const currentDate = moment().utc().format();
	const seedLoadSettingsParams = LoadSamplingProfileSettings.seed_load_sample_params;
	const cutterType = seedLoadSettingsParams.find((type) => type.key === 'cutter_type');
	const weightType = seedLoadSettingsParams.find((type) => type.key === 'weight_type');

	const usedInputs = ['cutter_type', 'weight_type', 'total_count', 'sample_weight']
	const sampleGeneralInputs = seedLoadSettingsParams.filter((type) => !usedInputs.includes(type.key));
	const generalInputsObjects = () => {
		let initialInputs = {};
		sampleGeneralInputs.forEach(e => {
			initialInputs[e.key] = null;
			initialInputs['files_url'] = [];
		})
		return initialInputs
	}

	const [generalInputs, /* setGeneralInputs */] = useState(generalInputsObjects())
	const cutterTypeHeader = cutterType.values
	const weightTypeBody = weightType.values
	const baseIcon = [{ key: 'cutter_type_1', urls: CutTopOrBottomIcon }, { key: 'cutter_type_2', urls: BarrelCutBottomIcon }, { key: 'cutter_type_3', urls: BarrelCutTopIcon }, { key: 'cutter_type_4', urls: HorizontalVerticalCutIcon }, { key: 'cutter_type_5', urls: OneDropIcon }]
	useEffect(() => {
		const totalLengthObjects = [];
		weightTypeBody.forEach((each) => {
			cutterTypeHeader.forEach((item) => {
				const newObj = {
					cutter_type: item.label,
					weight_type: each.label,
					cutter_id: item.key,
					weight_id: each.key,
					id: uuid(),
					total_count: null,
					sample_weight: null,
				};
				totalLengthObjects.push(newObj);
			});
		});

		const defaultSampleData = []
		const finalLengthObject = { ...generalInputs, id: uuid(), seed_piece_sample: [...totalLengthObjects] }
		defaultSampleData.push(finalLengthObject);

		setInitialSamplePieceData(defaultSampleData)

		let samplePieceData = seedSampleData && seedSampleData.length > 0 ? [...seedSampleData] : [...defaultSampleData];
		samplePieceData = [...samplePieceData].map((each) => {
			const filledSamplePieceData = totalLengthObjects.map(sample => {
				const correspondingObj = each.seed_piece_sample.find(obj => obj.cutter_id === sample.cutter_id && obj.weight_id === sample.weight_id);
				const data = correspondingObj ? { ...sample, ...correspondingObj } : sample;
				return data
			})
			return {
				...each,
				seed_piece_sample: filledSamplePieceData,
			}
		})

		const sampleImgObj = []
		samplePieceData.forEach((eachData) => {
			const defaultImg = {
				id: eachData.id,
				files_url: []
			};

			sampleImgObj.push(defaultImg)
		})

		let defaultsamplePieceData = seedSampleData && seedSampleData.length > 0 ? [...seedSampleData] : [];
		defaultsamplePieceData = [...defaultsamplePieceData].map((each) => {
			const filledSamplePieceData = totalLengthObjects.map(sample => {
				const correspondingObj = each.seed_piece_sample.find(obj => obj.cutter_id === sample.cutter_id && obj.weight_id === sample.weight_id);
				const data = correspondingObj ? { ...sample, ...correspondingObj } : sample;
				return data
			})
			return {
				...each,
				seed_piece_sample: filledSamplePieceData,
			}
		})

		const defaultSampleImgObj = []
		defaultsamplePieceData.forEach((eachData) => {
			const defaultImg = {
				id: eachData.id,
				files_url: []
			};

			defaultSampleImgObj.push(defaultImg)
		})

		setDefaultSamplerFile(defaultSampleImgObj)
		setSamplerFileURL(sampleImgObj)
		setDefaultLoadSample(defaultsamplePieceData)
		setLoadSamplePieceData(samplePieceData)
		setSamplerTabId(samplePieceData[0].id)
	}, [load]);

	useEffect(() => {
		if (seedSampleData && seedSampleData.length > 0) {
			setIsNewSample(true)
		}
	}, [load,seedSampleData])

	const handleDynamicInputs = (type, rowIndex, columnIndex, value, keyName, id) => {
		const newData = [...loadSamplePieceData];

		const updateData = newData.find((e) => e.id === id);
		let seedPieceSample = updateData.seed_piece_sample && updateData.seed_piece_sample.length > 0 ? [...updateData.seed_piece_sample] : [];
		const newValue = (type === 'number') ? parseFloat(value) : value;

		if (keyName === 'total_count' || keyName === 'sample_weight') {
			seedPieceSample = [...seedPieceSample].map((e) => {
				return {
					...e,
					[keyName]: (e.weight_id === rowIndex && e.cutter_id === columnIndex) ? newValue : e[keyName]
				}
			})
		}

		const updatedSeed = newData.map((item) => {
			return ({
				...item,
				seed_piece_sample: (item.id === id) ? [...seedPieceSample] : [...item.seed_piece_sample]
			})
		})

		setLoadSamplePieceData(updatedSeed)
	};

	const handleGeneralInputs = (type, value, keyName, id) => {
		const generalSample = [...loadSamplePieceData];
		const index = generalSample.findIndex((e) => e.id === id);

		if (type === 'text') {
			generalSample[index][keyName] = value;
		} else if (type === 'number') {
			generalSample[index][keyName] = Number(value) >= 0 ? Number(value) : 0;
		} else if (type === 'options') {
			generalSample[index][keyName] = (value && value.value) ? value.value : null;
		}

		setLoadSamplePieceData(generalSample);
	}

	const handleFileChange = (event, id, indexs) => {
		const files = event.target.files;
		if (files && files.length > 0) {
			setSamplerFiles(prevFiles => [...prevFiles, ...files]);
			const urls = Array.from(files).map(file => URL.createObjectURL(file));

			const updatedItems = samplerFileURL.map(item => {
				if (item.id === id) {
					return {
						...item,
						files_url: [...urls]
					};
				}
				return item;
			});
			setSamplerFileURL(updatedItems);
		}
	};

	const sampleDataKey = ['total_count', 'sample_weight'];
	const defaultInputs = ['seed_grower', 'seed_variety', 'seed_pulptemp', 'sampler_name', 'system_name']

	const hasNonNullValue = obj => {
		return sampleDataKey.some(property => obj[property] !== null);
	};

	const hasNonDefaultInputs = obj => {
		return defaultInputs.some(property => obj[property] !== null);
	};

	const handleSave = async () => {
		const samplerFiles = await saveSamplerFiles();
		const FilteredSampleData = [...loadSamplePieceData].filter(item => (hasNonDefaultInputs(item)))
		const editedIndex = FilteredSampleData.findIndex((e) => e.id === isEdit.id);

		if (isEdit.isEditing) {
			FilteredSampleData[editedIndex]['modified_by'] = getUserId();
			FilteredSampleData[editedIndex]['modified_date'] = currentDate;
		}

		const finalPayload = [...FilteredSampleData].map((each) => {
			return {
				...each,
				created_by: !each.created_by && each.created_by == null ? getUserId() : each.created_by,
				created_date: !each.created_date && each.created_date == null ? currentDate : each.created_date,
				modified_by: (!each.modified_by && each.modified_by == null && isAdded) ? null : (!isAdded && isEdit.id === each.id) ? getUserId() : each.modified_by,
				modified_date: (!each.modified_date && each.modified_date == null && isAdded) ? null : (!isAdded && isEdit.id === each.id) ? currentDate : each.modified_date,
				id: !each.id && each.id == null ? uuid() : each.id,
				files_url: samplerTabId === each.id ? [...each.files_url, ...samplerFiles] : [...each.files_url],
				seed_piece_sample: each.seed_piece_sample.filter(item => (hasNonNullValue(item)))
			}
		})

		if (finalPayload.length > 0) {
			await saveLoadSample(finalPayload);
			resetState();
			setIsNewSample(true)
			modalClose()
			setError(false)
		} else {
			setError(true)
		}
	}

	const saveLoadSample = async (samples) => {
		let saveLoad = {
			load_activity_uuid: load.load_activity_uuid,
			farm_uuid: load.farm_uuid,
			"seed_piece_profile": samples
		}
		return await saveSample(saveLoad);
	}

	const resetState = () => {
		setSamplerFiles([]);
		setIsAdded({ isAdding: false, id: null })
		setIsEdit({ isEditing: false, id: null })
	}

	const modalClose = () => {
		resetState();
		onHide();
	}

	const saveSamplerFiles = async () => {
		const attachments = samplerFiles.map((e) => {
			const exe = e.name.split('.').pop();
			return {
				file: e,
				name: `${uuid()}.${exe}`,
			}
		});
		const fileURL = [];
		for (const attachment of attachments) {
			const res = await uploadToGoogle({ attachment, uploadUrl: getLoadSamplerUploadURL(farmId, getUserId()) });
			if (res.status === 200) {
				const url = `${getLoadSamplerRetrieveURL(farmId, getUserId())}/${attachment.name}`;
				fileURL.push(url);
			}
		}
		return fileURL;
	};

	const handleTabButtonClick = (id) => {
		setSamplerTabId(id)
	}

	const handleAddButtonClick = (va) => {
		setIsNewSample(false)
		setIsEdit({ isEditing: false, id: null })
		setLoadSamplePieceData((prevSample) => [...prevSample, ...initialSamplePieceData])
		const id = initialSamplePieceData[0].id;
		const newImgObj = [{
			id: id,
			files_url: []
		}]

		setSamplerTabId(id)
		setIsAdded({ isAdding: true, id: id })
		setSamplerFileURL(preUrls => [...preUrls, ...newImgObj])
	}

	const handleReset = () => {
		setLoadSamplePieceData(defaultLoadSample)
		setIsEdit({ isEditing: false, id: null })
		// setGeneralInputs(defaultLoadSample)
		setSamplerFileURL(defaultSamplerFile)
		setSamplerFiles([])
	}

	const handleBack = () => {
		setIsNewSample(true)
		setLoadSamplePieceData(defaultLoadSample)
		setSamplerTabId(loadSamplePieceData[0].id)
		resetState()
	}

	const FinalCount = (key, id) => {
		const indexData = loadSamplePieceData.findIndex((e) => e.id === id)
		const totalWeight = loadSamplePieceData[indexData].seed_piece_sample.reduce((total, item) => total + (!item.sample_weight ? 0 : item.sample_weight), 0);
		const totalCount = loadSamplePieceData[indexData].seed_piece_sample.reduce((total, item) => total + (!item.total_count ? 0 : item.total_count), 0);
		const averageSize = totalWeight && totalCount ? (totalCount / totalWeight) : 0
		if (key === 'total_count') {
			return totalCount
		} else if (key === 'sample_weight') {
			return totalWeight
		} else if (key === 'average_size') {
			return unit.toFixedOf(averageSize, 2);
		}
	}

	return (<Modal show={show} onHide={onHide} className={`modal-form load_sample_container seed-cutter-modal_container`} size={`xl`} >
		<Form className="eg-form load-modal">
			<Modal.Header closeButton>
				<Modal.Title>
					<Heading6>{LoadSamplingProfileSettings.title}</Heading6>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="py-0">
				<div className='sample_piece_tabs_container'>
					{loadSamplePieceData.map((tabdata, tabindex) => {
						const isDisabled = ((isAdded.isAdding && tabdata.id !== isAdded.id) || (isEdit.isEditing && tabdata.id !== isEdit.id))
						return (
							<div key={`tabIndex${tabindex}`}>
								{isNewSample ? <div className={`sample_piece_tabs d-flex g-4 ${tabdata.id === samplerTabId ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`} onClick={() => handleTabButtonClick(tabdata.id)}>
									<h6>Seed Sample {tabindex + 1}</h6>
								</div> : null
								}
							</div>)
					})}

					<div className={`${isAdded.isAdding || (isEdit.isEditing && isEdit.id !== null) ? 'disabled' : ''} ${!isNewSample ? 'd-none' : 'd-block'}`}>
						<Button size="sm" variant="success" onClick={() => handleAddButtonClick()}>
							<Icon className="fa fa-plus-circle" />
						</Button>
					</div>
				</div>
				{loadSamplePieceData.map((data, index) => {
					const actualIndex = index;
					const isDisabled = (isAdded.isAdding && !isEdit.isEditing) || (!isAdded.isAdding && !isEdit.isEditing && data.id !== isEdit.id);
					return (
						<div key={data.id}>
							<div className={`tab_container ${samplerTabId !== null && data.id === samplerTabId ? "d-block active" : 'd-none'} ${isNewSample && isDisabled ? 'disabled' : ''}`}>
								<Row className='mb-2'>
									{sampleGeneralInputs.sort((a, b) => a - b).filter((e) => e.visible).map((item, index) => {
										const keyValue = item.key;
										const dropDownOptions = (Array.isArray(item.values) && item.values.length > 0)
											? item.values.map((elm) => {
												return { value: elm, label: elm }
											}) : []
										return (
											<Col sm={12} md={4} lg={3} key={index} >
												<Form.Group key={keyValue}>
													<Form.Label htmlFor={item.type === 'options' ? '' : (keyValue + index)}>{item.label} {item.required ? <small className="error-mand ml-1">*</small> : null}   </Form.Label>
													{item.type === 'options' ? (
														<Form.Select
															aria-label={keyValue + index}
															menuPortalTarget={document.body}
															id={keyValue + index}
															placeholder={`Select ${item.label}`}
															name={keyValue}
															onChange={(e) => handleGeneralInputs(item.type, e, item.key, data.id)}
															options={dropDownOptions}
															classNamePrefix="modal_dropdowm_select"
														/>

													) : (
														<Form.Control
															id={keyValue + index}
															value={data[item.key] !== null ? data[item.key] : ""}
															type={item.type}
															placeholder={`Enter ${item.label}`}
															className={`form-control ${error ? 'field_error' : ''}`}
															autoComplete="off"
															name={keyValue}
															onChange={(e) => handleGeneralInputs(item.type, e.target.value, item.key, data.id)}

														/>
													)}
												</Form.Group>
											</Col>
										)
									})
									}
								</Row>

								<DataTable className="seed_sample_table">
									<DataTable.Header className='seed_sample_header'>
										<DataTable.Row>
											<DataTable.Cell style={{ width: '30px' }}>Actual Weight</DataTable.Cell>
											{cutterTypeHeader.map((header, index) => (
												<DataTable.Cell className={`text-capitalize`} key={`head${index}`}>
													<div key={`head${index}`}>
														<div className='seed_sample_lable'>
															<div className='cutter_type_container mb-2'>
																{baseIcon.map((e) => {
																	if (e.key === header.key) {
																		return <img key={e.key} className='cutter_type_container_img' src={e.urls} alt="" />;
																	}
																	return null;
																})}
															</div>
															{header.label}
														</div>
														<div className='sample_details_header'>
															<span className='sample_text d-block'>Count</span>
															<span className='sample_text d-block'>Weight</span>
														</div>
													</div>
												</DataTable.Cell>
											))}
											<DataTable.Cell>
												<div className='seed_sample_lable seed_total px-0'>
													<div className='cutter_type_container mb-2'>
														<div className='cutter_type_container mb-2'>
															<div className='cutter_type_container_img' style={{ height: "30px" }}></div>
														</div>
														Total
													</div>
													<div className='sample_details_header'>
														<span className='sample_text d-block'>Count</span>
														<span className='sample_text d-block'>Weight</span>
													</div>
												</div>
											</DataTable.Cell>
										</DataTable.Row>
									</DataTable.Header>
									<DataTable.Body>
										{weightTypeBody.map((rowItem, rowIndex) => {

											const valueDataRow = loadSamplePieceData[actualIndex].seed_piece_sample.filter((e) => e.weight_id === rowItem.key)
											const totalSampleWeightRow = valueDataRow.reduce((total, item) => total + (!item.sample_weight ? 0 : item.sample_weight), 0);
											const totalCountRow = valueDataRow.reduce((total, item) => total + (!item.total_count ? 0 : item.total_count), 0);
											return <DataTable.Row key={rowIndex}>
												<DataTable.Cell>{rowItem.label}</DataTable.Cell>
												{cutterTypeHeader.map((columnItem, columnIndex) => {
													const isDataHasSample = (loadSamplePieceData[actualIndex].seed_piece_sample && loadSamplePieceData[actualIndex].seed_piece_sample.length > 0);
													const totalCountValue = (isDataHasSample && loadSamplePieceData[actualIndex].seed_piece_sample.find(data => (data.cutter_id === columnItem.key && data.weight_id === rowItem.key)).total_count !== null) ? loadSamplePieceData[actualIndex].seed_piece_sample.find(e => e.cutter_id === columnItem.key && e.weight_id === rowItem.key).total_count : '';
													const sampleWeightValue = (isDataHasSample && loadSamplePieceData[actualIndex].seed_piece_sample.find(data => (data.cutter_id === columnItem.key && data.weight_id === rowItem.key)).sample_weight !== null) ? loadSamplePieceData[actualIndex].seed_piece_sample.find(e => e.cutter_id === columnItem.key && e.weight_id === rowItem.key).sample_weight : '';


													return (<DataTable.Cell key={`header_${columnIndex}`}>
														<div className={`seed_input_container header_${columnIndex}`}>
															<input
																className='seed_inputs'
																type='number'
																placeholder='0'
																disabled={rowItem.key === 'total'}
																value={totalCountValue || ''}
																onChange={(e) => handleDynamicInputs('number', rowItem.key, columnItem.key, e.target.value, 'total_count', data.id)}
															/>
															<input
																className='seed_inputs'
																type='number'
																placeholder='0'
																disabled={rowItem.key === 'total'}
																value={sampleWeightValue || ''}
																onChange={(e) => handleDynamicInputs('number', rowItem.key, columnItem.key, e.target.value, 'sample_weight', data.id)}
															/>
														</div>
													</DataTable.Cell>)
												})}
												<DataTable.Cell>
													<div className={`seed_total_container row_cell`}>
														<div className='seed_inputs_total'>{totalCountRow}</div>
														<div className='seed_inputs_total'>{totalSampleWeightRow}</div>
													</div>
												</DataTable.Cell>
											</DataTable.Row>
										})}

										<DataTable.Row>
											<DataTable.Cell>Total</DataTable.Cell>
											{cutterTypeHeader.map((columnItem, columnIndex) => {
												const valueData = loadSamplePieceData[actualIndex].seed_piece_sample.filter((e) => e.cutter_id === columnItem.key)
												const totalSampleWeight = valueData.reduce((total, item) => total + (!item.sample_weight ? 0 : item.sample_weight), 0);
												const totalCount = valueData.reduce((total, item) => total + (!item.total_count ? 0 : item.total_count), 0);

												return (<DataTable.Cell key={`header_${columnIndex} seed_total_cell`}>
													<div className={`seed_total_container row_cell`}>
														<div className='seed_inputs_total'>{totalCount}</div>
														<div className='seed_inputs_total'>{totalSampleWeight}</div>
													</div>
												</DataTable.Cell>)
											})}
											<DataTable.Cell style={{ minWidth: '90px' }}>
												<div className={`seed_total_container`}>
													<div className='seed_inputs_total'>{FinalCount("total_count", data.id)}</div>
													<div className='seed_inputs_total'>{FinalCount("sample_weight", data.id)}</div>
												</div>
											</DataTable.Cell>
										</DataTable.Row>
									</DataTable.Body>
								</DataTable>
								<Col lg='12' className='px-0'>
									<div className='average_size_container py-2'>
										<div className='averagesize_text'>
											<h6>Average Size: </h6>
											<span>{FinalCount("average_size", data.id)}</span>
										</div>
									</div>
								</Col>
								<Col lg='12'>
									<div className='seed_sample_upload'>

										{loadSamplePieceData && loadSamplePieceData.length > 0 ? loadSamplePieceData[actualIndex].files_url.map((url, index) => (
											<div key={`loaded_${index}`} className={`seed_upload_img_list`}>
												<img src={url} alt={`Uploaded ${index + 1}`} />
											</div>
										)) : null}

										{samplerFileURL && samplerFileURL[actualIndex].files_url.map((url, index) => (
											<div key={`Uploaded_${actualIndex + index}`} className={`seed_upload_img_list`}>
												<img src={url} alt={`Uploaded ${actualIndex + 1}`} />
											</div>
										))}

										<div key={`index_${actualIndex}`} className={`seed_upload_input index_${actualIndex}`}>
											<input type="file" id={`fileInput_${actualIndex}`} multiple onChange={(event) => handleFileChange(event, data.id, actualIndex)} style={{ display: 'none' }} />
											<label htmlFor={`fileInput_${actualIndex}`}>Choose File</label>
										</div>
									</div>
								</Col>
							</div>
						</div>
					)
				})}

			</Modal.Body>
			<Modal.Footer>
				<Button size="sm" variant="danger" onClick={modalClose}>
					<Icon className="fa fa-ban" /> Close
				</Button>

				{isEdit.isEditing &&
					<Button size="sm" className='border-dark' variant="light" onClick={() => handleReset()}>
						<Icon className="fa fa-repeat" /> Reset
					</Button>}

				{!isEdit.isEditing && !isAdded.isAdding && isNewSample ? <Button size="sm" variant="secondary" onClick={() => setIsEdit({ isEditing: true, id: samplerTabId })} >
					<Icon className="fa fa-pencil" /> Edit
				</Button>
					:
					!isNewSample ?
						<>
							{loadSamplePieceData.length > 1 && <Button size="sm" variant={`secondary`} onClick={() => handleBack()} >
								<Icon className={`fa fa-arrow-left`} /> Back
							</Button>}
							<Button size="sm" variant={`success`} onClick={() => handleSave()} >
								<Icon className={`fa fa-plus-circle`} /> Add Sample
							</Button>
						</> :
						<Button size="sm" variant={`primary`} onClick={() => handleSave()} >
							<Icon className={`fa fa-floppy-o`} /> Save
						</Button>
				}
			</Modal.Footer>
		</Form >
	</Modal >)
}

export default LoadSampleProfileTable;
